import React from 'react'
import { useIntl } from 'react-intl'
import { CreateDropoffCreatorErrors } from '../../../core/application/formValidation/createDropoffFormValidator'
import { NewDropoffCreator } from '../../../core/domain/models/NewDropoff'
import InputContainer, { InputContainerBackground } from '../inputs/InputContainer'
import TextInput, { AutocompleteType } from '../inputs/TextInput'

export interface ISubmitDropoffCreatorProps {
    creator?: NewDropoffCreator
    updateCreator: (creator: NewDropoffCreator) => void,
    errors?: CreateDropoffCreatorErrors,
    shouldDisplayErrors: boolean
}

const SubmitDropoffCreator: React.FC<ISubmitDropoffCreatorProps> = ({
    creator,
    updateCreator,
    errors,
    shouldDisplayErrors
}) => {
    const intl = useIntl()

    const onEmailChange = (newValue: string) => {
        updateCreator({
            ...creator,
            email: newValue
        } as NewDropoffCreator)
    }

    return (
        <InputContainer 
            errorIntlKey={shouldDisplayErrors && errors?.email ? errors.email : undefined }
            background={InputContainerBackground.transparent}
        >
            <TextInput 
                placeholder={intl.formatMessage({id: 'SubmitDropoff.creator.email.placeholder'})}
                onChange={onEmailChange}
                value={creator?.email || ''}
                id='email'
                autoComplete={AutocompleteType.email}
            />
        </InputContainer>
    )
}

export default SubmitDropoffCreator
